import type { PropsWithChildren, ReactNode } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { Placeholder } from './internals/placeholder';

export type DetailPlaceholderType = 'client' | 'number' | 'document';

interface AddressPlaceholderProps {
  detailType: DetailPlaceholderType;
}

const typeToPlaceholder: Record<DetailPlaceholderType, PLACEHOLDERS> = {
  client: PLACEHOLDERS.ClientDetailsValue,
  number: PLACEHOLDERS.DocumentNumberValue,
  document: PLACEHOLDERS.DocumentDetailsValue,
};

export function DetailValuePlaceholder({
  detailType,
  children,
}: PropsWithChildren<AddressPlaceholderProps>): ReactNode {
  const { showPlaceholder } = usePlaceholders(typeToPlaceholder[detailType]);

  if (showPlaceholder) {
    return <Placeholder width="71px" />;
  }

  return <>{children}</>;
}
